import React, { ReactNode } from 'react';
import { CenteredDashboardContent } from 'features/dashboard/DashboardContent';

interface ContractualizationLayoutProps {
  /** Label above the card when several files go together (optional) */
  fileSelectorTitle?: ReactNode;
  /** File tabs, at the very top of the card, above the quote tabs (optional) */
  fileSelector?: ReactNode;
  /** Tabs component (optional) */
  tabs?: ReactNode;
  /** Header component */
  header?: ReactNode;
  /** Main content sections */
  children: ReactNode;
  /** Additional class for the card container */
  cardClassName?: string;
}

/**
 * Layout générique pour les pages de contractualisation
 * Utilisé par ContractualizationStep et BorrowerContractualizationStep
 */
export const ContractualizationLayout: React.FC<ContractualizationLayoutProps> = ({
  fileSelectorTitle,
  fileSelector,
  tabs,
  header,
  children,
  cardClassName = ''
}) => {
  return (
    <CenteredDashboardContent>
      <div className="flex flex-col gap-2.5 max-w-5xl mx-auto">
        {fileSelectorTitle}
        {fileSelector || tabs ? (
          <div className={`bg-white border border-gray-200 overflow-hidden rounded-xl shadow-sm ${cardClassName}`}>
            {fileSelector}
            {tabs}
            <div className="flex flex-col gap-4 p-8">
              {header}
              {children}
            </div>
          </div>
        ) : (
          <div className={`flex flex-col gap-4 p-8 bg-white border border-gray-200 rounded-xl shadow-sm ${cardClassName}`}>
            {header}
            {children}
          </div>
        )}
      </div>
    </CenteredDashboardContent>
  );
};
